import {useAppDispatch, useAppSelector} from './useReduxHooks'
import * as actions from '../redux/reducers/users/service'
import {useCallback} from 'react'
import {
  ActivateUserRequest,
  ActivateUsersExceptRequest,
  CreateUserRequest,
  DeleteUserRequest,
  FetchAllUsersRequest,
  FetchUserByIdRequest,
  FetchUsersRequest,
  SuspendUserRequest,
  SuspendUsersExceptRequest,
  UpdateUserRequest,
} from '../redux/reducers/users/types'

export default function useUsers() {
  const dispatch = useAppDispatch()
  const {users, userForEdit, listLoading, actionLoading, error, total, totalPages} = useAppSelector(
    (state) => state.users
  )

  const fetchUsers = (props: FetchUsersRequest) => {
    return dispatch(actions.fetchUsers(props))
  }

  const fetchAllUsers = useCallback((props: FetchAllUsersRequest) => {
    return dispatch(actions.fetchAllUsers(props))
  }, [dispatch])

  const fetchUserById = (props: FetchUserByIdRequest) => {
    return dispatch(actions.fetchUserById(props))
  }

  const createUser = (props: CreateUserRequest) => {
    return dispatch(actions.createUser(props))
  }

  const updateUser = (props: UpdateUserRequest) => {
    return dispatch(actions.updateUser(props))
  }

  const deleteUser = (props: DeleteUserRequest) => {
    return dispatch(actions.deleteUser(props))
  }

  const suspendUser = (props: SuspendUserRequest) => {
    return dispatch(actions.suspendUser(props))
  }

  const activateUser = (props: ActivateUserRequest) => {
    return dispatch(actions.activateUser(props))
  }

  const suspendUsersExcept = (props: SuspendUsersExceptRequest) => {
    return dispatch(actions.suspendUsersExcept(props))
  }

  const activateUsersExcept = (props: ActivateUsersExceptRequest) => {
    return dispatch(actions.activateUsersExcept(props))
  }

  return {
    total,
    totalPages,
    userForEdit,
    users,
    listLoading,
    actionLoading,
    error,
    fetchUsers,
    fetchUserById,
    createUser,
    updateUser,
    deleteUser,
    suspendUser,
    activateUser,
    fetchAllUsers,
    teachers: users.filter((u) => u.role === '3'),
    students: users.filter((u) => u.role === '4' || u.role === '8'), // Include both regular and limited students
    parents: users.filter((u) => u.role === '5'),
    suspendUsersExcept,
    activateUsersExcept,
  }
}
